


/**/


document.addEventListener("DOMContentLoaded", function() {

  var footerElement = document.querySelector('#Footer-custom_BDHkg4 .footer__collapsible');
  if (footerElement) {
    var newDiv = document.createElement('div');
    newDiv.className = 'klaviyo-form-W5qWsM';
    footerElement.appendChild(newDiv);
  }
  
  document.querySelectorAll('.gNQL2uhoDK > div').forEach(col => {
  const button = col.querySelector('a.gp-button-base');
  if (button) {
    const link = button.href;

    // Set click event on the entire column
    col.style.cursor = 'pointer';
    col.addEventListener('click', () => {
      window.location.href = link;
    });
    
    // Optional: Stop propagation when clicking the button to avoid double navigation
    button.addEventListener('click', (event) => event.stopPropagation());
  }
});

  
  const menuToggle = document.getElementById("mobile-menu-toggle");
  const mobileMenu = document.getElementById("mobile-menu");

  if(menuToggle && mobileMenu){

  menuToggle.addEventListener("click", function() {
    if (mobileMenu.style.display === "none" || mobileMenu.style.display === "") {
       menuToggle.querySelector('img').src = "//3foodies.de/cdn/shop/files/close.png?v=7469286937619641686";
      mobileMenu.style.display = "flex";
      menuToggle.classList.add('opened');
    } else {
      menuToggle.querySelector('img').src = "//3foodies.de/cdn/shop/files/Frame_2085661254.png?v=4893806453983280334";
      mobileMenu.style.display = "none";
      menuToggle.classList.remove('opened');
    }
  });
    }

  const carouselItems = document.querySelectorAll(".jdgm-carousel-item");

  carouselItems.forEach(item => {
    // Select the name wrapper and review elements within each item
    const nameWrapper = item.querySelector(".jdgm-carousel-item__reviewer-name-wrapper");
    const reviewContent = item.querySelector(".jdgm-carousel-item__review");

    // Check if both elements exist before moving
    if (nameWrapper && reviewContent) {
      reviewContent.appendChild(nameWrapper); // Move nameWrapper inside reviewContent
    }
  });

  const newsletterSubmit = document.querySelector(".newsletter-section__content .input-group .form__submit--large");
    if (newsletterSubmit) {
        newsletterSubmit.textContent = "Zum Newsletter anmelden";
    }

  const priceElement = document.querySelector(".vv-single-product-meta .product__price");

    if (priceElement) {
        priceElement.textContent = priceElement.textContent.replace("EUR", "€");
    }

});


document.addEventListener("DOMContentLoaded", function () {
  const drawerInner = document.querySelector(".drawer__inner");
  if (!drawerInner) return; 
  drawerInner.addEventListener("click", function (e) {
    if (e.target.classList.contains("text-link")) {
      e.preventDefault();
      const itemKey = new URL(e.target.href).searchParams.get("id"); // Extract item ID from the URL
      fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.error("Error removing item:", error);
        });
    }
  });
});


  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href="/collections/all"]');
    links.forEach(link => {
      link.setAttribute('href', '/collections/alle-produkte');
    });
  });

/** Add to cart / Buy now buttons in collection view */

const addToCart = (variantId) => {
  return new Promise((resolve, reject) => {
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId),
          quantity: 1
        }]
      }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => resolve(data))
      .catch(error => reject(error));
  })
}

document.addEventListener('DOMContentLoaded', function() {
  const gridItems = Array.from(document.querySelectorAll('.grid__item.grid-product'));
  gridItems.forEach(item => {
    const variantId = item.dataset.variantId;
    const buyNowButton = item.querySelector('.js-product-grid-buy-now-button');

    if (buyNowButton) {
      buyNowButton.addEventListener('click', function() {
        buyNowButton.classList.add('btn--loading');
        addToCart(variantId).then(data => {
          window.location = '/cart/checkout'
        }).catch(err => {
          buyNowButton.classList.remove('btn--loading');
          console.error(err);
          alert('Fehler beim Hinzufügen zum Warenkorb');
        });
      });
    }
    const addToCartButton = item.querySelector('.js-product-grid-add-to-cart-button');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function() {
        addToCartButton.classList.add('btn--loading');
        addToCart(variantId).then(data => {
          addToCartButton.classList.remove('btn--loading');
          document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
            detail: {
              product: data,
              addToCartBtn: addToCartButton
            },
            bubbles: true
          }));
        }).catch(err => {
          addToCartButton.classList.remove('btn--loading');
          console.error(err);
          alert('Fehler beim Hinzufügen zum Warenkorb');
        });
      });
    }
  })
});